import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface LangState {
	lang: string;
}

const initialLang = localStorage.getItem("lang") || "al";

const initialState: LangState = {
	lang: initialLang,
};

const langSlice = createSlice({
	name: "lang",
	initialState,
	reducers: {
		setLanguage(state, action: PayloadAction<string>) {
			state.lang = action.payload;
			localStorage.setItem("lang", action.payload);
		},
	},
});

export const { setLanguage } = langSlice.actions;
export default langSlice.reducer;
